import React from "react";

import { IconProps } from "../types";

import { Path } from "./Path";

export const LockClosed = ({ className, color }: IconProps) => (
  <svg
    width={24}
    height={24}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={className}
    style={{ color }}
  >
    <Path
      color={color}
      d="M18 8.45117H17V6.45117C17 3.69117 14.76 1.45117 12 1.45117C9.24 1.45117 7 3.69117 7 6.45117V8.45117H6C4.9 8.45117 4 9.35117 4 10.4512V20.4512C4 21.5512 4.9 22.4512 6 22.4512H18C19.1 22.4512 20 21.5512 20 20.4512V10.4512C20 9.35117 19.1 8.45117 18 8.45117ZM12 17.4512C10.9 17.4512 10 16.5512 10 15.4512C10 14.3512 10.9 13.4512 12 13.4512C13.1 13.4512 14 14.3512 14 15.4512C14 16.5512 13.1 17.4512 12 17.4512ZM15.1 8.45117H8.9V6.45117C8.9 4.74117 10.29 3.35117 12 3.35117C13.71 3.35117 15.1 4.74117 15.1 6.45117V8.45117Z"
    />
  </svg>
);
